<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-title>{{ title() }}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" text="{{ 'COMMON.BACK' | translate }}" />
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  @switch (store.vendorsListByFilterState().type) {
    @case ("loading") {
      <div class="flex items-center justify-center">
        <ion-spinner class="mt-24 size-10" name="circles" />
      </div>
    }
    @case ("error") {
      <mtjr-error [failure]="store.vendorsFailure()" />
    }
    @case ("success") {
      <div
        data-cy="vendors-list"
        class="grid w-full grid-cols-1 gap-2 px-4 pb-4 pt-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6"
      >
        @for (vendor of store.vendors(); track $index) {
          <ion-card
            data-cy="vendor-card"
            class="!m-0 my-1.5 rounded-xl"
            [routerLink]="[vendor.id]"
            routerDirection="forward"
          >
            <img [src]="vendor.background ?? 'assets/store-placeholder.jpg'" class="h-32 w-full object-cover" alt="" />
            <div class="flex items-center">
              <div class="flex flex-1 flex-col px-4 pb-3 pt-2">
                <ion-text color="dark" class="line-clamp-1 text-lg font-bold">{{ vendor.name }}</ion-text>
              </div>
              <ion-avatar slot="start" class="border-light size-10 border-2 border-solid mx-4">
                @if (vendor.logo) {
                  <img [src]="vendor.logo" />
                }
              </ion-avatar>
            </div>
          </ion-card>
        }
      </div>
      @if (store.vendors().length === 0) {
        <div class="flex w-full flex-col items-center justify-center">
          <mtjr-dynamic-img
            src="/assets/no_products.svg"
            darkSrc="/assets/no_products_dark.svg"
            class="size-[180px] opacity-80 dark:opacity-70"
          />

          <p class="text-medium/70 mt-5 text-center">{{ "VENDORS.NO_VENDORS_TO_SHOW" | translate }}</p>
        </div>
      }
    }
  }

  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
